module.exports = __webpack_public_path__ + "img/triangle.45b871a5.png";